import { Component, ElementRef, OnInit, ViewChild } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "src/environments/environment"
import { map, startWith } from "rxjs/operators"
import { FormControl, Validators } from "@angular/forms"
import { BaseService } from "src/app/services/base.service"
import { AuthService } from "src/app/services/auth.service"
import { Router } from "@angular/router"
import { Location } from "@angular/common"

@Component({
	selector: "app-error-report",
	templateUrl: "./error-report.component.html",
	styleUrls: ["./error-report.component.scss"]
})
export class ErrorReportComponent implements OnInit {
	public assets_version = environment.ASSETS_VERSION
	public waitSubmit = false
	public isLogged: boolean = false

	optionsList: string[]
	issue_type = new FormControl("", [Validators.required])
	fileNames: string[] = []
	public fileNamesToDisplay: string = ""

	@ViewChild("fileInput", { static: true }) inputRef: ElementRef
	@ViewChild("form", { static: true }) form

	public errorReport = {
		name: "",
		surname: "",
		email: "",
		subject: "",
		body: "",
		upload_files: []
	}

	errorMessage: string

	constructor(
		public baseService: BaseService,
		public authService: AuthService,
		public router: Router,
		public location: Location
	) {}

	ngOnInit() {
		if (this.authService.isLogged) {
			this.isLogged = true
			this.prefillData()
			this.optionsList = [
				"Data loading problems",
				"Visualization problems",
				"Feature not working",
				"Feature clarification needed"
			]
		} else {
			this.isLogged = false
			this.optionsList = [
				"Create new user",
				"Password recovery problems",
				"Login problems not related to user/password"
			]
		}
	}

	onFileSelected(e) {
		for (const file of e.target.files) {
			// if (file.name && this.isFileAllowed(file.name)) {
			this.convertToBase64(file).then(attachment => {
				this.errorReport.upload_files.push({
					attachment_name: file.name,
					attachment
				})
				this.createInputNames(file.name)
			})
			// } else {
			//   this.baseService.toastr.error('File must be .JPG or .PNG or .JPEG or .PDF', '', this.baseService.toastrOptions);
			// }
		}
	}

	createInputNames(fileName) {
		this.fileNames.push(fileName)
		if (this.fileNames.length > 1) {
			this.fileNamesToDisplay = this.fileNames.join(", ")
		} else {
			this.fileNamesToDisplay = this.fileNames[0]
		}
	}

	onSubmit() {
		if (this.disabled) {
			return
		}
		this.waitSubmit = true
		this.errorMessage = ""
		this.errorReport["issue_type"] = this.issue_type.value
		this.baseService.reportIssue(this.errorReport).subscribe(
			() => {
				this.waitSubmit = false
				this.baseService.showSuccess("Issue reported correctly")
				this.clearForm()
			},
			err => {
				this.baseService.showError(err)
				this.waitSubmit = false
				this.errorMessage = err.error.error.message
				if (err.error.error.violations) {
					for (const violation of err.error.error.violations) {
						this.errorMessage += "\n" + violation.property + ": " + violation.message
					}
				}
			}
		)
	}

	clear() {
		this.errorReport.upload_files = []
		this.fileNames = []
		this.fileNamesToDisplay = ""
		this.inputRef.nativeElement.value = ""
	}

	clearForm() {
		if (!this.authService.isLogged) {
			this.errorReport.name = ""
			this.errorReport.surname = ""
			this.errorReport.email = ""
		} else {
		}
		;(this.errorReport.subject = ""), (this.errorReport.body = ""), (this.errorReport.upload_files = [])
		this.fileNames = []
		this.fileNamesToDisplay = ""
		this.inputRef.nativeElement.value = ""
		this.issue_type.setValue("")
		this.issue_type.markAsUntouched()
		this.form.resetForm()
	}

	resetError() {
		this.errorMessage = ""
	}

	get disabled() {
		if (
			this.errorReport &&
			this.errorReport.subject &&
			this.errorReport.subject.length &&
			this.issue_type &&
			this.issue_type.value &&
			this.errorReport.body &&
			this.errorReport.body.length
		) {
			if (
				this.baseService.isLogged ||
				(!this.baseService.isLogged && this.errorReport.email && this.errorReport.email.length)
			) {
				return false
			} else {
				return true
			}
		} else {
			return true
		}
	}

	private convertToBase64(file: File) {
		return new Promise(resolve => {
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => resolve(reader.result.toString().replace(/^data:.+;base64,/, ""))
		})
	}

	private prefillData() {
		this.authService.getUserData().subscribe(res => {
			this.errorReport.email = res.email
			this.errorReport.name = res.name
			this.errorReport.surname = res.surname
		})
	}

	isFileAllowed(fileName: string) {
		let isFileAllowed = false
		const allowedFiles = [
			".jpg",
			".png",
			".pdf",
			".jpeg",
			".doc",
			".docx",
			".JPG",
			".PNG",
			".PDF",
			".JPEG",
			".DOC",
			".DOCX"
		]
		const regex = /(?:\.([^.]+))?$/
		const extension = regex.exec(fileName)
		if (undefined !== extension && null !== extension) {
			for (const ext of allowedFiles) {
				if (ext === extension[0]) {
					isFileAllowed = true
				}
			}
		}
		return isFileAllowed
	}
}
